import Vue from 'vue'
import VueRouter from 'vue-router';
import Router from 'vue-router'

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'manage',
    component: () => import('@/views/ManageLayout.vue'),
    children:[
      { 
        path: 'home',
        component: () => import('../views/manage/HomeView.vue')
      }
    ]
  },
    {
      path: '/manage',
      name: 'manage',
      component: () => import('@/views/ManageLayout.vue'),
      children:[
        { 
          path: 'home',
          component: () => import('../views/manage/HomeView.vue')
        },
        {
          path: 'about',
          component: () => import('../views/manage/AboutView.vue')
        }
      ]
    },
    {
      path: '/customer',
      name: 'customer',
      component: () => import('@/views/ManageLayout.vue'),
      children:[
        { 
          path: 'list',
          component: () => import('../views/customer/CustomerList.vue')
        }
      ]
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/views/ManageLayout.vue'),
      children:[
        { 
          path: 'list',
          component: () => import('../views/product/ProductList.vue')
        }
      ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

export default  router;